import { func, any, string, oneOfType, elementType, object } from 'prop-types';
var children$1 = any;
var svg$1 = func.isRequired;
var hover = string;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var sx$1 = object;
var variant$1 = string;
var themeUiBase = {
  as: oneOfType([string, elementType]),
  sx: sx$1
};

var themeUi$1 = _extends({}, themeUiBase, {
  variant: variant$1
});

var sxProperty = any;
var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  children: children$1,
  svg: svg$1,
  hover: hover,
  sx: sx$1,
  variant: variant$1,
  themeUiBase: themeUiBase,
  themeUi: themeUi$1,
  sxProperty: sxProperty
});

var boolean = function boolean(_ref) {
  var _ref2;

  var name = _ref.name,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue,
      description = _ref.description;
  return _ref2 = {}, _ref2[name] = {
    name: name,
    description: description ? description : "Controls the \"" + name + "\" state of the component",
    defaultValue: defaultValue,
    control: {
      type: 'boolean'
    },
    table: {
      type: {
        summary: 'bool'
      }
    }
  }, _ref2;
};

var svg = function svg(name) {
  var _ref3;

  return _ref3 = {}, _ref3[name] = {
    name: name,
    description: 'Takes a SVGR Component',
    control: false,
    table: {
      type: {
        summary: 'func',
        detail: 'SVGR > https://react-svgr.com/docs/webpack/#usage',
        required: true
      }
    }
  }, _ref3;
};

var nodeLabel = {
  label: {
    name: 'aria-label',
    description: 'Defaults to the children node text automatically',
    control: {
      type: 'text'
    },
    table: {
      type: {
        summary: 'string',
        detail: 'The text (static or dynamic) of the children will be used by default'
      }
    }
  }
};
var childrenText = {
  children: {
    name: 'children',
    description: 'This component accepts text as children',
    control: {
      type: 'text'
    },
    table: {
      type: {
        summary: 'string',
        detail: 'Using a component as children might have undesired effects',
        required: true
      }
    }
  }
};
var children = {
  children: {
    name: 'children',
    description: 'The children accepts content of any kind',
    control: false,
    table: {
      type: {
        summary: 'any',
        required: true
      }
    }
  }
}; // as: {
//   name: 'as',
//   description: 'Takes an HTML tag or Component to be redered as',
//   defaultValue: '',
//   control: { type: 'text' },
//   table: {
//     type: {
//       summary: 'node',
//       detail: 'Emotion props: emotion.sh/docs/styled#as-prop',
//     },
//   },
// },

var as = {
  as: {
    name: 'as',
    description: 'Takes an html tag or Component to be redered as',
    control: false,
    table: {
      type: {
        summary: 'string || element',
        detail: 'Emotion > https://emotion.sh/docs/styled#as-prop'
      }
    }
  }
};
var sx = {
  sx: {
    name: 'sx',
    description: 'Takes Theme UI css / jsx styles',
    table: {
      type: {
        summary: 'object',
        detail: 'Theme UI > https://theme-ui.com/sx-prop'
      }
    }
  }
};

var themeUi = _extends({}, as, sx);

var variant = function variant(_ref) {
  var _ref2;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? false : _ref$variants,
      description = _ref.description;
  var control = variants && {
    type: 'select'
  };
  var options = variants && Object.keys(variants).map(function (variant) {
    return variant;
  });
  var key = name ? name : 'variant';
  return _ref2 = {}, _ref2[key] = {
    name: key,
    description: description ? description : "Name of a " + (name && name + ' ') + "variant key > " + (name ? name : 'variant') + ".{key}",
    defaultValue: defaultValue,
    control: control,
    options: options,
    table: {
      type: {
        summary: 'string',
        detail: 'Theme UI > https://theme-ui.com/guides/variants/'
      }
    }
  }, _ref2;
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: boolean,
  svg: svg,
  nodeLabel: nodeLabel,
  childrenText: childrenText,
  children: children,
  as: as,
  sx: sx,
  themeUi: themeUi,
  variant: variant
});
export { index as args, index$1 as props };